<template>
  <!-- Notifications -->
  <li class="nav-item dropdown flag-nav dropdown-heads">
    <a class="nav-link" data-bs-toggle="dropdown">
      <i class="feather feather-bell"></i>
      <span v-if="unreadmessage" class="badge rounded-pill"></span>
    </a>
    <div class="dropdown-menu notifications">
      <div class="topnav-dropdown-header">
        <span class="notification-title">Notifications</span>
        <a
          v-if="unreadmessage"
          @click="markAllAsRead"
          class="clear-noti"
          style="color: #3865b0"
        >
          Mark all as read</a
        >
      </div>
      <div class="noti-content">
        <div
          v-if="notifications?.length === 0"
          class="d-flex h-100 align-center justify-center"
        >
          <p>No Notifications</p>
        </div>
        <ul v-else class="notification-list">
          <li
            v-for="message in notifications"
            :key="message.id"
            class="notification-message"
            @click="showNotification(message.id)"
          >
            <a>
              <div class="media d-flex">
                <div class="avatar avatar-sm">
                  <span
                    class="avatar-title rounded-circle"
                    :class="{
                      'bg-info-light': !message.read,
                      'bg-primary-light': message.read,
                    }"
                    ><i class="far fa-comment"></i
                  ></span>
                </div>
                <div class="media-body">
                  <p
                    :class="{
                      'noti-title': !message.read,
                      'noti-details': message.read,
                    }"
                    v-html="message.title"
                  ></p>
                  <p class="noti-time">
                    <span class="notification-time">{{
                      timeAgo(message.created_at)
                    }}</span>
                  </p>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!-- <div class="topnav-dropdown-footer">
        <router-link to="/activities">View all Notifications</router-link>
      </div> -->
    </div>
  </li>
  <!-- /Notifications -->
  <!-- <li class="nav-item has-arrow dropdown-heads">
    <a href="javascript:void(0);" class="win-maximize" @click="initFullScreen">
      <i class="feather feather-maximize"></i>
    </a>
  </li> -->
</template>
<script setup>
import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import { timeAgo } from "@/assets/composables/date";

const store = useStore();

const notifications = computed(() => {
  return store.getters["auth/notifications"];
});

const getNotifications = () => {
  store.dispatch("auth/getNotifications");
};

const showNotification = (id) => {
  store.dispatch("auth/showNotification", id);
};

const markAllAsRead = async () => {
  await store.dispatch("auth/markAllAsRead").then(() => {
    getNotifications();
  });
};

const unreadmessage = computed(() => {
  return notifications.value[0]?.read === false;
});

const setLanguage = (locale, country, flag) => {
  this.lan = locale;
  this.text = country;
  this.flag = flag;
};
const initFullScreen = () => {
  document.body.classList.toggle("fullscreen-enable");
  if (
    !document.fullscreenElement &&
    /* alternative standard method */
    !document.mozFullScreenElement &&
    !document.webkitFullscreenElement
  ) {
    // current working methods
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen(
        Element.ALLOW_KEYBOARD_INPUT
      );
    }
  } else {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }
};

onMounted(() => {
  getNotifications();
});
</script>
